import Request from './baseRequest'

const getUserToken = () => {
	return JSON.parse(localStorage.getItem('auth.currentUser')).token;
}

const _getEventsGeneralStats = params => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.get(
      `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/dashboard-indicators?${params}`,
      config
    )
}

const _getEventsGeneralStatsLastSyncDate = () => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.get(
      `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/last-replication-date`,
      config
    )
}

const _getEventsList = params => {
    const token = getUserToken()
    const config = {
      headers: {
        authorization: `Bearer ${token}`
      }
    }
  
    return Request.get(
      `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/events-list?${params}`,
      config
    )
}

const _getTotalAmountSold = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/total-sold?${params}`,
    config
  )
}

const _getTotalAmountSoldByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/total-sold-by-day?${params}`,
    config
  )
}

const _getEventsByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/events-by-day?${params}`,
    config
  )
}

const _getAllEventsByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/all-events-by-day?${params}`,
    config
  )
}

const _getVideoIndicators = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/video-indicators?${params}`,
    config
  )
}

const _getVideoCustomersCount = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/customers-count-video?${params}`,
    config
  )
}

const _getVideoSessions = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/video-sessions?${params}`,
    config
  )
}

const _createLiveshopLogsExport = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.post(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/logs-export?${params}`,
    {},
    config
  )
}

const _getVideoSessionsByDay = params => {
  const token = getUserToken()
  const config = {
    headers: {
      authorization: `Bearer ${token}`
    }
  }

  return Request.get(
    `${window.config.VUE_APP_BACKEND}/api/liveshopping-analytics/video-sessions-by-day?${params}`,
    config
  )
}

export default {
    getTotalAmountSold: _getTotalAmountSold,
    getEventsList: _getEventsList,
    getEventsGeneralStats: _getEventsGeneralStats,
    getEventsGeneralStatsLastSyncDate: _getEventsGeneralStatsLastSyncDate,
    getTotalAmountSoldByDay: _getTotalAmountSoldByDay,
    getEventsByDay: _getEventsByDay,
    getAllEventsByDay: _getAllEventsByDay,
    getVideoIndicators: _getVideoIndicators,
    getVideoCustomersCount: _getVideoCustomersCount,
    getVideoSessions: _getVideoSessions,
    createLiveshopLogsExport: _createLiveshopLogsExport,
    getVideoSessionsByDay: _getVideoSessionsByDay
}